import React, { useRef } from 'react'
import Papa from 'papaparse'

const CSVFileInput = ({
  cssClass = '',
  label = 'Choose a file',
  onFileLoaded,
  onError,
  inputId = 'csv-input'
}) => {
  const fileInputRef = useRef(null)

  const handleFileChange = (event) => {
    const file = event.target.files[0]
    if (!file) return

    Papa.parse(file, {
      header: false,
      skipEmptyLines: false,
      complete: (results) => {
        if (onFileLoaded) {
          onFileLoaded(results.data)
        }
        // Reset input so the same file can be selected again
        if (fileInputRef.current) {
          fileInputRef.current.value = ''
        }
      },
      error: (error) => {
        if (onError) {
          onError(error)
        }
      }
    })
  }

  return (
    <div className={cssClass}>
      <input
        ref={fileInputRef}
        type="file"
        id={inputId}
        className="csv-input"
        accept=".csv"
        onChange={handleFileChange}
      />
      <label htmlFor={inputId}>{label}</label>
    </div>
  )
}

export default CSVFileInput
